import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { professionalAction, userActions } from "../../_actions";
import AropiReport2Plus from "./AropiReport";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Modal,
  Spin,
  Space,
  Typography,
  Dropdown,
  Menu,
  Radio,
} from "antd";
import {
  Document9,
  DocumentCount,
  DocumentCount1,
} from "./ReportDocuments/Document_9";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { ViewFormModel } from "./ViewForm/ViewFormModel";
import { TwoPlusService } from "../../_services/towplus.service";
import { twoPlusAction } from "../../_actions/twoplus.actions";
import MyTable from "./ReportDocuments/MyTable";
import { LanguageContext } from "../../context/LanguageContext";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  ClearOutlined,
  DownOutlined,
  DownloadOutlined,
  FilterOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { mapAdminCityAction } from "../../_actions/mapAdminCity.action";
import { adminServiceAction } from "../../_actions/admin.service";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
import { downloadGunaListPdf } from "../../_helpers/downloadGunaListPdf";
import { RoleByService } from "../../_services/roleby.service";

const { Text } = Typography;

const TableReport2Plus = React.lazy(() =>
  import("./Tables/TableReport2Plus").then((module) => ({
    default: module.TableReport2Plus,
  })),
);

const { RangePicker } = DatePicker;
const { Option } = Select;

class Plus2ReportAdmin extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }
  state = {
    filter: "",
    total: 0,
    loading: false,
    downloadLoding: false,
    report_4_startDate: "",
    report_4_endDate: "",
    report4_loader: false,
    report4_List: [],
    report4_List1: [],
    report4_List_Total: 0,
    report4_API_loader: false,
    totalCriminal: 0,
    crimeTitle: [],
    setCriminalViewModel: false,
    PlusViewForm_List: [],
    report_type: null,
    newArophiData: [],
    arophiCount: [],
    arophiListCount: [],
    arophiList: [],
    historyCount: [],
    historyList: [],
    showList: "सांख्यिकी",
    showModal: false,
    download: "arophi_excel",
    total: "",
    dates: [],
    showFilterSection: false,
    order_by: "",
    direction: "",
    is_sort: false,
    tableSort: { field: "", order: "" },
    selectedLastDistricts: [],
    selectedPreventiveStatuses: [],
    visibleExportIds: null,
    preventiveAction: [],
    districtIds: "",
    advancedFilterPhoto: "all",
    mapped_cities: [],
    selected_city: [],
    activeMainTab: "list",
    graphAppliedStartDate: "",
    graphAppliedEndDate: "",
    graphRefreshKey: 0,
  };

  userMapCityDetails = () => {
    let temp = {
      id: this.props.user.id,
    };
    mapAdminCityAction.userMapCityDetails(temp).then((res) => {
      const cities = res.results || [];
      this.setState({
        mapped_cities: cities,
        selected_city: cities.map((city) => city.id),
      });
    });
  };

  selectfilter = (value) => {
    this.setState(
      {
        filter: value,
        advancedFilterPhoto: "all",
      },
      () => {},
    );
  };
  getPreventiveInfo = () => {
    professionalAction.getPreventiveAction().then((res) => {
      res &&
        res.text().then((preventiveList) => {
          const data = [];
          preventiveList &&
            JSON.parse(preventiveList).data.forEach((item) => {
              data.push(item);
            });
          this.setState({
            preventiveAction: data,
            preventiveActionData: JSON.parse(preventiveList),
          });
        });
    });
  };

  getPreventiveExportStatus = (item) => {
    const records = item?.prevetive_records?.length
      ? item.prevetive_records
      : item?.prevetive_record?.length
        ? item.prevetive_record
        : [];
    if (!records.length) return "-";

    const firstRecord = records[0];
    if (!firstRecord?.date_to) return "-";

    return moment(firstRecord.date_to).isBefore(moment(), "day")
      ? "completed"
      : "ongoing";
  };

  applyListViewToExport = (items) => {
    let result = [...(items || [])];
    const visibleIds = this.state.visibleExportIds;
    if (this.state.showList === "यादी" && Array.isArray(visibleIds)) {
      const idSet = new Set(visibleIds.map((id) => String(id)));
      result = result.filter((item) =>
        idSet.has(String(item.masterId ?? item.id)),
      );
    } else {
      const selected = this.state.selectedLastDistricts || [];
      if (selected.length > 0) {
        result = result.filter((item) =>
          selected.includes(item.last_districtName),
        );
      }

      const selectedStatuses = this.state.selectedPreventiveStatuses || [];
      if (selectedStatuses.length > 0) {
        result = result.filter((item) =>
          selectedStatuses.includes(this.getPreventiveExportStatus(item)),
        );
      }
    }

    const { field, order } = this.state.tableSort || {};
    if (field && order) {
      const direction = order === "descend" ? -1 : 1;
      result.sort((a, b) => {
        if (field === "totalCrimeCount") {
          const aCount = Number(a.totalCrimeCount) || 0;
          const bCount = Number(b.totalCrimeCount) || 0;
          return direction * (aCount - bCount);
        }
        if (field === "last_districtName") {
          const cmp = String(a.last_districtName || "").localeCompare(
            String(b.last_districtName || ""),
            undefined,
            { sensitivity: "base" },
          );
          return direction * cmp;
        }
        return 0;
      });
    }

    return result;
  };

  getExportRows = () => {
    const { t } = this.context;
    const { showList } = this.state;
    let list = [];
    const data = this.applyListViewToExport(
      this.state.report_type === "arophi_new_list"
        ? this.state.arophiListCount
        : this.state.report4_List,
    );
    console.log("data", data);
    list =
      this.state.report_type == "history_sheeter"
        ? this.state.report4_List &&
          this.state.report4_List.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("name")]: data.name ? data.name : "-",
            [t("address")]: data.address ? data.address : "-",
            [t("age")]: data.age ? data.age : "-",
            [t("history_sheeter_entry_date")]: data.history_date
              ? moment(data.history_date).format("DD-MM-YYYY")
              : "-",
            [t("accused_police_station")]: data.districtName
              ? data.districtName
              : "-",
            [t("total_crimes ")]: data.totalCrimeCount
              ? data.totalCrimeCount
              : "-",
            [t("photo")]: data.photo ? t("yes") : t("no"),
          }))
        : data &&
          data.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("accused_police_station")]: data.districtName
              ? data.districtName
              : data.crime_districtName
                ? data.crime_districtName
                : "-",
            [t("name")]: data.name ? data.name : "-",
            [t("address")]: data.address ? data.address : "-",
            [t("total_crimes")]: data.totalCrimeCount
              ? data.totalCrimeCount
              : "-",
            "शेवटचा गुन्ह्याचे पो. स्टे": data.last_districtName
              ? data.last_districtName
              : "-",
            "CR.No/DateTime": `${data.cr_no ? data.cr_no : "-"} - ${
              data.guna_date ? data.guna_date : "-"
            }`,
            [t("photo")]: data.photo ? t("yes") : t("no"),
          }));
    console.log("final list", list);
    let list2 = [];
    list2 =
      this.state.report_type === "new arophi"
        ? this.state.report4_List1 &&
          this.state.report4_List1 &&
          this.state.report4_List1.map((data, index) => {
            const मालाविषयक = parseInt(data["मालाविषयक"]) || 0;
            const शरीराविषयक = parseInt(data["शरीराविषयक"]) || 0;
            const अवैध_वाळू_विषयक = parseInt(data["अवैध वाळू विषयक"]) || 0;
            const अवैध_दारु_विषयक = parseInt(data["अवैध दारु विषयक"]) || 0;
            const जुगारविषयक = parseInt(data["जुगारविषयक"]) || 0;
            const भाग_६ = parseInt(data["भाग - ६"]) || 0;
            const इतर = parseInt(data["भाग - ६"]) || 0;

            const total =
              मालाविषयक +
              शरीराविषयक +
              अवैध_वाळू_विषयक +
              अवैध_दारु_विषयक +
              जुगारविषयक +
              भाग_६ +
              इतर;

            return {
              [t("sr.no")]: index + 1,
              [t("crime_police_station")]: data.districtName,
              [t("body_offender")]: शरीराविषयक,
              [t("property_offender")]: मालाविषयक,
              [t("illegal_sand_transportation")]: अवैध_वाळू_विषयक,
              [t("illegal_liquor_related")]: अवैध_दारु_विषयक,
              [t("gambling_related")]: जुगारविषयक,
              [t("section_6")]: भाग_६,
              [t("other_crimes")]: इतर,
              [t("total")]: total,
            };
          })
        : this.state.report_type === "history_sheeter"
          ? this.state.report4_List1 &&
            this.state.report4_List1.map((data, index) => {
              return {
                [t("sr.no")]: index + 1,
                [t("police_station")]: data.districtName,
                [t("history_sheeter_statistics")]: data.Count_district,
              };
            })
          : this.state.report4_List1 &&
            this.state.report4_List1.map((data, index) => {
              return {
                [t("sr.no")]: index + 1,
                [t("police_station")]: data.districtName,
                [t("2_plus_statistics")]: data.crimeCount,
              };
            });
    console.log("showList", showList);
    const arrData1 =
      showList === "सांख्यिकी" || this.state.report_type == "new arophi"
        ? list2
        : list;

    return arrData1;
  };

  download_pdf = async () => {
    const { t } = this.context;
    const { filter } = this.state;
    const arrData = this.getExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    let ReportTitle = "";
    const title =
      this.state.report_type === "new arophi"
        ? t("accused_new_cases_statistics")
        : this.state.report_type === "arophi count" &&
            this.state.showList === "सांख्यिकी"
          ? t("two_plus_accused")
          : this.state.report_type === "arophi_new_list"
            ? t("two_plus_accused_list")
            : this.state.report_type == "more_than_two_plus_list"
              ? t("accused_combined_list_2_plus")
              : t("two_plus_accused");

    if (this.state.report_type === "new arophi") {
      ReportTitle = t("accused_new_cases_statistics");
    } else if (
      this.state.report_type === "arophi count" &&
      this.state.showList === "सांख्यिकी"
    ) {
      ReportTitle = `${t("two_plus_accused")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : `${t("data_entered_by_police_station1")} - ${t("statistics1")}`
      }`;
    } else if (this.state.report_type === "arophi_new_list") {
      ReportTitle = `${t("two_plus_accused_list")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : t("data_entered_by_police_station1")
      }`;
    } else if (this.state.report_type === "more_than_two_plus_list") {
      ReportTitle = `${t("accused_combined_list_2_plus")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : t("data_entered_by_police_station1")
      }`;
    } else if (this.state.report_type === "history_sheeter") {
      ReportTitle = `${t("history")} - ${
        this.state.showList === "सांख्यिकी" ? t("statistics1") : t("list")
      }`;
    } else {
      ReportTitle = `${t("two_plus_accused")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : t("data_entered_by_police_station1")
      }`;
    }
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: ReportTitle,
        dateRangeText: getReportDateRangeText(
          this.state.report_4_startDate,
          this.state.report_4_endDate,
        ),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  getGunaReportTitle = () => {
    const { t } = this.context;
    const { filter } = this.state;

    if (this.state.report_type === "new arophi") {
      return t("accused_new_cases_statistics");
    }
    if (
      this.state.report_type === "arophi count" &&
      this.state.showList === "सांख्यिकी"
    ) {
      return `${t("two_plus_accused")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits")
          : `${t("data_entered_by_police_station")} - ${t("statistics1")}`
      }`;
    }
    if (this.state.report_type === "arophi_new_list") {
      return `${t("two_plus_accused_list")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_crime")
          : t("data_entered_by_police_crime")
      }`;
    }
    if (this.state.report_type === "more_than_two_plus_list") {
      return `${t("accused_combined_list_2_plus")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_crime")
          : t("data_entered_by_police_crime")
      }`;
    }
    return `${t("two_plus_accused")} - ${
      filter === "by_distinct"
        ? t("info_within_police_station_limits")
        : t("data_entered_by_police_station")
    }`;
  };

  getGunaFileName = () => {
    const { t } = this.context;
    const report_name =
      this.state.report_type === "new arophi"
        ? t("accused_new_cases_statistics")
        : this.state.report_type === "arophi count" &&
            this.state.showList === "सांख्यिकी"
          ? t("two_plus_accused")
          : this.state.report_type === "arophi_new_list"
            ? t("two_plus_accused_list")
            : this.state.report_type === "more_than_two_plus_list"
              ? t("accused_combined_list_2_plus")
              : t("two_plus_accused");
    return `${report_name}_${moment().format("DDMMMYYYY")}`;
  };

  getGunaExportTableData = () => {
    const { t } = this.context;
    const criminalList = this.state.report4_List || [];
    const accusedFixedCols = 6;

    const currentStatusLabel = `${t("current_status")} (${moment().format(
      "DD-MM-YYYY",
    )})`;

    const headers = [
      t("sr.no"),
      t("accused_police_station"),
      t("name"),
      t("address"),
      t("total_crimes"),
      t("photo"),
      t("title"),
      t("crime_police_station"),
      t("crime_register_number"),
      t("crime_register_year"),
      t("crime_registration_date"),
      t("law_and_section"),
      t("preventive_action"),
      currentStatusLabel,
      t("date_from"),
      t("date_to"),
    ];

    const rows = [];
    const accusedGroups = [];

    const buildDetailRow = (gunha, action) => {
      const detailRow = [];

      if (gunha) {
        detailRow.push(
          gunha.crime_title || "-",
          gunha.districtName || "-",
          gunha.registernumber || "-",
          gunha.registernumberYear
            ? moment(gunha.registernumberYear).format("YYYY")
            : "-",
          gunha.dateTime ? moment(gunha.dateTime).format("DD/MM/YYYY") : "-",
        );

        let lawData = "-";
        if (gunha.kk_info?.length) {
          const grouped = {};
          gunha.kk_info.forEach((r) => {
            const name = r.rulesName || "-";
            const kalma = r.kalam || "-";
            grouped[name] = grouped[name]
              ? Array.from(new Set([...grouped[name], kalma]))
              : [kalma];
          });
          lawData = Object.entries(grouped)
            .map(([n, k]) => `${n}: ${k.join(", ")}`)
            .join("\n");
        }
        detailRow.push(lawData);
      } else {
        detailRow.push("", "", "", "", "", "");
      }

      if (action) {
        detailRow.push(
          action.preventive_action_name || "-",
          action.date_to && moment(action.date_to).isBefore(moment(), "day")
            ? t("completed")
            : t("ongoing"),
          action.date_from
            ? moment(action.date_from).format("DD-MM-YYYY")
            : "-",
          action.date_to ? moment(action.date_to).format("DD-MM-YYYY") : "-",
        );
      } else {
        detailRow.push("", "", "", "");
      }

      return detailRow;
    };

    criminalList.forEach((accused, idx) => {
      const gunhas = accused.gunha_records || [];
      const preventive = accused.prevetive_records || [];
      const maxRows = Math.max(gunhas.length, preventive.length, 1);
      const detailRows = [];

      const accusedCells = [
        idx + 1,
        accused.districtName || accused.crime_districtName || "-",
        accused.name || "-",
        accused.address || "-",
        accused.totalCrimeCount || "-",
        accused.photo?.length && accused.photo[0] !== "" ? "Yes" : "No",
      ];

      for (let i = 0; i < maxRows; i++) {
        const gunha = gunhas[i];
        const action = preventive[i];
        const detailRow = buildDetailRow(gunha, action);
        detailRows.push(detailRow);

        const row = [...accusedCells];
        if (i > 0) {
          for (let k = 0; k < accusedFixedCols; k++) row[k] = "";
        }
        rows.push([...row, ...detailRow]);
      }

      accusedGroups.push({
        accused: accusedCells,
        detailRows,
      });
    });

    return {
      headers,
      rows,
      accusedGroups,
      reportTitle: this.getGunaReportTitle(),
      file_name: this.getGunaFileName(),
    };
  };

  download_guna_pdf = async () => {
    const { t } = this.context;
    const { headers, accusedGroups, reportTitle, file_name } =
      this.getGunaExportTableData();

    if (!accusedGroups.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    const dateRangeText = `${t("from")} ${moment(
      this.state.report_4_startDate,
    ).format("DD-MM-YYYY")} - ${t("to")} ${moment(
      this.state.report_4_endDate,
    ).format("DD-MM-YYYY")}`;

    this.setState({ downloadLoding: true });
    try {
      await downloadGunaListPdf({
        headerText,
        reportTitle,
        dateRangeText,
        headers,
        accusedGroups,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  downloadReport = () => {
    const { download, crimeTitle } = this.state;
    if (download == "guna_excel") {
      this.download_csv();
    }
    if (download == "arophi_excel" || download === "excel") {
      this.download_csv1();
    }
    if (download == "guna_pdf") {
      this.download_guna_pdf();
    }
    if (download == "pdf") {
      this.download_pdf();
    }
  };
  onCityChange = () => {
    this.props.dispatch(
      professionalAction.getDistrict(this?.props?.user?.cityId, 1),
    );
  };

  getShowList = (value) => {
    if (this.props.user?.role === "12" && value !== "सांख्यिकी") {
      return;
    }
    this.setState({ showList: value, selectedPreventiveStatuses: [] });
  };

  hasSelectedCities = (selected_city = this.state.selected_city) =>
    Array.isArray(selected_city) && selected_city.length > 0;

  toggleGraphView = () => {
    const isGraphView = this.state.activeMainTab === "graph";
    if (isGraphView) {
      this.setState((prev) => ({
        activeMainTab: "list",
        showList: prev.showList === "graph" ? "सांख्यिकी" : prev.showList,
      }));
      return;
    }

    this.setState({ activeMainTab: "graph" }, () => {
      if (this.canLoadGraph()) {
        this.handleGraphFind();
      }
    });
  };

  canLoadGraph = (state = this.state) => {
    const {
      report_type,
      filter,
      report_4_startDate,
      report_4_endDate,
      isMoreThanOneYear,
      selected_city,
    } = state;

    if (!report_type) return false;
    if (report_type !== "new arophi" && !filter) return false;
    if (this.props.user?.role === "12" && !this.hasSelectedCities(selected_city))
      return false;
    if (!report_4_startDate || !report_4_endDate || isMoreThanOneYear) {
      return false;
    }
    return true;
  };

  handleGraphFind = () => {
    if (!this.canLoadGraph()) return;
    const { report_4_startDate, report_4_endDate } = this.state;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    this.setState((prev) => ({
      graphAppliedStartDate: startDate,
      graphAppliedEndDate: endDate,
      graphRefreshKey: (prev.graphRefreshKey || 0) + 1,
    }));
  };

  isFindDisabled = () => {
    const {
      activeMainTab,
      showList,
      districtIds,
      report_type,
      report_4_startDate,
      report_4_endDate,
      isMoreThanOneYear,
      filter,
      selected_city,
    } = this.state;

    if (this.props.user?.role === "12" && !this.hasSelectedCities(selected_city))
      return true;

    if (activeMainTab === "graph") {
      if (!report_type) return true;
      if (report_type !== "new arophi" && !filter) return true;
      if (!report_4_startDate || !report_4_endDate || isMoreThanOneYear) {
        return true;
      }
      return false;
    }

    if (
      showList === "यादी" &&
      !districtIds &&
      report_type === "history_sheeter" &&
      (!report_4_startDate || isMoreThanOneYear)
    ) {
      return true;
    }
    if (
      report_type !== "history_sheeter" &&
      (!report_4_startDate || isMoreThanOneYear)
    ) {
      return true;
    }
    return false;
  };

  handleFind = () => {
    if (this.isFindDisabled()) return;
    if (this.state.activeMainTab === "graph") {
      this.handleGraphFind();
    } else {
      this.getData();
    }
  };

  getData = () => {
    this.setState({
      total: 0,
    });
    if (this.state.report_type === "new arophi") this.get2lusNewArophiCount();
    if (
      this.state.report_type === "arophi count" &&
      this.state.showList == "यादी"
    ) {
      this.get2PlusNewArophiList();
    }
    if (
      this.state.report_type === "arophi count" &&
      this.state.showList == "सांख्यिकी"
    ) {
      this.get2lusArophiCount1();
    }
    if (
      this.state.report_type === "arophi_new_list" &&
      this.state.showList == "यादी"
    ) {
      this.get2lusArophiListCount();
    }
    if (
      this.state.report_type === "arophi_new_list" &&
      this.state.showList == "सांख्यिकी"
    ) {
      this.get2lusNewListArophiCount();
    }
    if (
      this.state.report_type === "more_than_two_plus_list" &&
      this.state.showList == "सांख्यिकी"
    ) {
      this.getAccusedListWithTwoOrMoreCount();
    }
    if (
      this.state.report_type === "more_than_two_plus_list" &&
      this.state.showList == "यादी"
    ) {
      this.getAccusedListWithTwoOrMoreList();
    }
  };

  getAccusedListWithTwoOrMoreList = () => {
    const {
      report_4_startDate,
      report_4_endDate,
      crimeTitle,
      order_by,
      direction,
    } = this.state;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const { user } = this.props;
    this.setState({
      report4_API_loader: true,
    });
    let obj = {
      startDate: startDate,
      endDate: endDate,
      cityId:
        user.role === "12" ? this.state.selected_city : user && user.cityId,
      heading: crimeTitle,
      order_by: order_by ? order_by : "",
      direction: direction ? direction : "",
    };

    if (this.state.filter === "by_distinct") {
      if (["4", "12"].includes(user.role)) {
        adminServiceAction
          .getAccusedListWithTwoOrMoreListByDistinct(obj)
          .then((res) => {
            let list = res.results;

            let tempFilterData = _.filter(
              list && _.flatten(list),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });

            this.setState({
              arophiListCount: tempObj,
              report4_API_loader: false,
              report4_List: tempObj,
              report4_List1: tempObj,
              total: tempObj.length,
              report4_List_backup: tempObj,
              arophiList: tempObj,
            });
            if ((order_by && direction) || this.state.crimeTitle.length > 0) {
              this.setState({
                is_sort: true,
              });
            }
          });
      } else {
        const temp = {
          startDate: startDate,
          endDate: endDate,
          districtId: user && user.map_districtId,
          heading: crimeTitle,
          order_by: order_by ? order_by : "",
          direction: direction ? direction : "",
        };
        RoleByService.getAccusedListWithTwoOrMoreListByRole(temp).then(
          (res) => {
            let list = res.results;

            let tempFilterData = _.filter(
              list && _.flatten(list),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });

            this.setState({
              arophiListCount: tempObj,
              report4_API_loader: false,
              report4_List: tempObj,
              report4_List1: tempObj,
              total: tempObj.length,
              report4_List_backup: tempObj,
              arophiList: tempObj,
            });
            if ((order_by && direction) || this.state.crimeTitle.length > 0) {
              this.setState({
                is_sort: true,
              });
            }
          },
        );
      }
    }
    if (this.state.filter === "by_id") {
      if (["4", "12"].includes(user.role)) {
        adminServiceAction
          .getAccusedListWithTwoOrMoreListById(obj)
          .then((res) => {
            let list = res.results;

            let tempFilterData = _.filter(
              list && _.flatten(list),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });

            this.setState({
              arophiListCount: tempObj,
              report4_API_loader: false,
              report4_List: tempObj,
              report4_List1: tempObj,
              total: tempObj.length,
              report4_List_backup: tempObj,
              arophiList: tempObj,
            });
            if ((order_by && direction) || this.state.crimeTitle.length > 0) {
              this.setState({
                is_sort: true,
              });
            }
          });
      } else {
        const temp = {
          startDate: startDate,
          endDate: endDate,
          districtId: user && user.map_districtId,
          heading: crimeTitle,
          order_by: order_by ? order_by : "",
          direction: direction ? direction : "",
        };

        RoleByService.getAccusedListWithTwoOrMoreListIdByRole(temp).then(
          (res) => {
            let list = res.results;

            let tempFilterData = _.filter(
              list && _.flatten(list),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });

            this.setState({
              arophiListCount: tempObj,
              report4_API_loader: false,
              report4_List: tempObj,
              report4_List1: tempObj,
              total: tempObj.length,
              report4_List_backup: tempObj,
              arophiList: tempObj,
            });
            if ((order_by && direction) || this.state.crimeTitle.length > 0) {
              this.setState({
                is_sort: true,
              });
            }
          },
        );
      }
    }
  };
  getAccusedListWithTwoOrMoreCount = () => {
    const { report_4_startDate, report_4_endDate } = this.state;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const { user } = this.props;
    this.setState({
      report4_API_loader: true,
    });
    if (this.state.filter == "by_distinct") {
      if (["4", "12"].includes(user.role)) {
        let cityId =
          user.role === "12" ? this.state.selected_city : user && user.cityId;
        let obj = {
          startDate: startDate,
          endDate: endDate,
          cityId: cityId,
        };
        adminServiceAction
          .getAccusedListWithTwoOrMoreCountByDistinct(obj)
          .then((res) => {
            let list = res.results;

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });
            let totalCrimeCount = columns1.reduce(
              (sum, res) => sum + (Number(res.crimeCount) || 0),
              0,
            );

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });
            this.setState({
              arophiCount: tempObj,
              report4_API_loader: false,
              report4_List1: list,
              report4_List: list,
              total: totalCrimeCount,
            });
          });
      } else {
        let temp = {
          startDate: startDate,
          endDate: endDate,
          districtId: user.map_districtId,
        };
        RoleByService.getAccusedListWithTwoOrMoreCountDistinctByRole(temp).then(
          (res) => {
            let list = res.results;

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });
            let totalCrimeCount = columns1.reduce(
              (sum, res) => sum + (Number(res.crimeCount) || 0),
              0,
            );

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });
            this.setState({
              arophiCount: tempObj,
              report4_API_loader: false,
              report4_List1: list,
              report4_List: list,
              total: totalCrimeCount,
            });
          },
        );
      }
    }
    if (this.state.filter === "by_id") {
      if (["4", "12"].includes(user.role)) {
        let cityId =
          user.role === "12" ? this.state.selected_city : user && user.cityId;
        let obj = {
          startDate: startDate,
          endDate: endDate,
          cityId: cityId,
        };
        adminServiceAction
          .getAccusedListWithTwoOrMoreCountById(obj)
          .then((res) => {
            let list = res.results;

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });
            let totalCrimeCount = columns1.reduce(
              (sum, res) => sum + (Number(res.crimeCount) || 0),
              0,
            );

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });
            this.setState({
              arophiCount: tempObj,
              report4_API_loader: false,
              report4_List1: list,
              report4_List: list,
              total: totalCrimeCount,
            });
          });
      } else {
        const temp = {
          startDate: startDate,
          endDate: endDate,
          districtId: user.map_districtId,
        };
        RoleByService.getAccusedListWithTwoOrMoreCountIdByRole(temp).then(
          (res) => {
            let list = res.results;

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });
            let totalCrimeCount = columns1.reduce(
              (sum, res) => sum + (Number(res.crimeCount) || 0),
              0,
            );

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });
            this.setState({
              arophiCount: tempObj,
              report4_API_loader: false,
              report4_List1: list,
              report4_List: list,
              total: totalCrimeCount,
            });
          },
        );
      }
    }
  };

  get2lusNewArophiCount = () => {
    const { report_4_startDate, report_4_endDate } = this.state;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const { user } = this.props;
    this.setState({
      report4_API_loader: true,
    });
    if (["4", "12"].includes(user.role)) {
      let city =
        user.role === "12" ? this.state.selected_city : user && user.cityId;
      twoPlusAction
        .get2lusNewArophiCount(startDate, endDate, city)
        .then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });

              this.setState({
                newArophiData: tempObj,
                report4_API_loader: false,
                report4_List: list,
                report4_List1: list,
                total: list.length,
              });
            });
        });
    }
    if (user?.role === "9" || user?.role === "10") {
      let obj = {
        startDate: startDate,
        endDate: endDate,
        districtId: user?.map_districtId,
      };
      twoPlusAction.get2lusNewArophiCountByRole(obj).then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });

            this.setState({
              newArophiData: tempObj,
              report4_API_loader: false,
              report4_List: list,
              report4_List1: list,
              total: list.length,
            });
          });
      });
    }
  };

  get2lusArophiCount1 = () => {
    const { report_4_startDate, report_4_endDate } = this.state;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const { user } = this.props;
    this.setState({
      report4_API_loader: true,
    });
    if (this.state.filter == "by_distinct") {
      if (["4", "12"].includes(user.role)) {
        let cityId =
          user.role === "12" ? this.state.selected_city : user && user.cityId;
        twoPlusAction
          .get2lusArophiCount(startDate, endDate, cityId)
          .then((res) => {
            res &&
              res.text().then((criminalList1) => {
                let criminal = JSON.parse(criminalList1);
                let list = criminal.results;

                let columns1 =
                  list &&
                  list &&
                  list.map((itemObj, index) => {
                    return {
                      ...itemObj,
                    };
                  });
                let totalCrimeCount = columns1.reduce(
                  (sum, res) => sum + (Number(res.crimeCount) || 0),
                  0,
                );

                let tempObj = columns1.map((res, index) => {
                  return {
                    ...res,
                  };
                });
                this.setState({
                  arophiCount: tempObj,
                  report4_API_loader: false,
                  report4_List1: list,
                  report4_List: list,
                  total: totalCrimeCount,
                });
              });
          });
      }
      if (user?.role === "9" || user?.role === "10") {
        let obj = {
          startDate: startDate,
          endDate: endDate,
          districtId: user?.map_districtId,
        };
        twoPlusAction.get2lusArophiCountByRole(obj).then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let totalCrimeCount = list.reduce(
                (sum, res) => sum + (Number(res.crimeCount) || 0),
                0,
              );
              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });

              this.setState({
                arophiCount: tempObj,
                report4_API_loader: false,
                report4_List1: list,
                report4_List: list,
                total: totalCrimeCount,
              });
            });
        });
      }
    }
    if (this.state.filter === "by_id") {
      if (["4", "12"].includes(user.role)) {
        let obj = {
          startDate: startDate,
          endDate: endDate,
          cityId:
            user.role === "12" ? this.state.selected_city : user && user.cityId,
        };
        twoPlusAction.get2PlusNewAropiPostBharaliCount(obj).then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });
              let totalCrimeCount = columns1.reduce(
                (sum, res) => sum + (Number(res.crimeCount) || 0),
                0,
              );
              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });
              this.setState({
                arophiCount: tempObj,
                report4_API_loader: false,
                report4_List1: list,
                report4_List: list,
                total: totalCrimeCount,
              });
            });
        });
      }
      if (user?.role === "9" || user?.role === "10") {
        let obj = {
          startDate: startDate,
          endDate: endDate,
          districtId: user?.map_districtId,
        };
        twoPlusAction
          .get2PlusNewAropiPostBharaliCountByRole(obj)
          .then((res) => {
            res &&
              res.text().then((criminalList1) => {
                let criminal = JSON.parse(criminalList1);
                let list = criminal.results;

                let columns1 =
                  list &&
                  list &&
                  list.map((itemObj, index) => {
                    return {
                      ...itemObj,
                    };
                  });

                let totalCrimeCount = columns1.reduce(
                  (sum, res) => sum + (Number(res.crimeCount) || 0),
                  0,
                );
                let tempObj = columns1.map((res, index) => {
                  return {
                    ...res,
                  };
                });
                this.setState({
                  arophiCount: tempObj,
                  report4_API_loader: false,
                  report4_List1: list,
                  report4_List: list,
                  total: totalCrimeCount,
                });
              });
          });
      }
    }
  };

  get2PlusNewArophiList = () => {
    const {
      report_4_startDate,
      report_4_endDate,
      crimeTitle,
      order_by,
      direction,
    } = this.state;
    const { user } = this.props;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    this.setState({
      report4_API_loader: true,
    });
    let obj = {
      startDate: startDate,
      endDate: endDate,
      cityId:
        user.role === "12" ? this.state.selected_city : user && user.cityId,
      heading: crimeTitle,
      order_by: order_by ? order_by : "",
      direction: direction ? direction : "",
    };
    let policeobj = {
      startDate: startDate,
      endDate: endDate,
      id: user && user.districtId,
      heading: crimeTitle,
      order_by: order_by ? order_by : "",
      direction: direction ? direction : "",
    };
    let districtobj = {
      startDate: startDate,
      endDate: endDate,
      districtId: user && user.map_districtId,
      heading: crimeTitle,
      order_by: order_by ? order_by : "",
      direction: direction ? direction : "",
    };
    if (user?.role === "2") {
      twoPlusAction
        .get2plusNewArophiListPoliceStation(policeobj)
        .then((res) => {
          res &&
            res.text().then(async (text) => {
              const criminal = text && JSON.parse(text);
              let list = criminal.results;

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });
              this.setState({
                arophiList: tempObj,
                report4_API_loader: false,
                report4_List: list,
                total: list.length,
                report4_List_backup: list,
              });
              if ((order_by && direction) || this.state.crimeTitle.length > 0) {
                this.setState({
                  is_sort: true,
                });
              }
            });
        });
    }
    if (user?.role === "9" || user?.role === "10") {
      if (this.state.filter == "by_distinct") {
        twoPlusAction.getPlus2ArophiListByRole(districtobj).then((res) => {
          res &&
            res.text().then(async (text) => {
              const criminal = text && JSON.parse(text);
              let list = criminal.results;

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });
              this.setState({
                arophiList: tempObj,
                report4_API_loader: false,
                report4_List: list,
                total: list.length,
                report4_List_backup: list,
              });
              if ((order_by && direction) || this.state.crimeTitle.length > 0) {
                this.setState({ is_sort: true });
              } else {
                this.setState({ is_sort: false });
              }
            });
        });
      }
      if (this.state.filter === "by_id") {
        twoPlusAction
          .get2PlusNewAropiPostBharaliListByRole(districtobj)
          .then((res) => {
            res &&
              res.text().then(async (text) => {
                const criminal = text && JSON.parse(text);
                let list = criminal.results;

                let columns1 =
                  list &&
                  list &&
                  list.map((itemObj, index) => {
                    return {
                      ...itemObj,
                    };
                  });

                let tempObj = columns1.map((res, index) => {
                  return {
                    ...res,
                  };
                });
                this.setState({
                  arophiList: tempObj,
                  report4_API_loader: false,
                  report4_List: list,
                  report4_List1: list,
                  total: list.length,
                  report4_List_backup: list,
                });
                if (
                  (order_by && direction) ||
                  this.state.crimeTitle.length > 0
                ) {
                  this.setState({ is_sort: true });
                } else {
                  this.setState({ is_sort: false });
                }
              });
          });
      }
    } else {
      if (this.state.filter == "by_distinct") {
        twoPlusAction.get2PlusNewArophiList(obj).then((res) => {
          res &&
            res.text().then(async (text) => {
              const criminal = text && JSON.parse(text);
              let list = criminal.results;

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });
              this.setState({
                arophiList: tempObj,
                report4_API_loader: false,
                report4_List: list,
                total: list.length,
                report4_List_backup: list,
                report4_List1: list,
              });
              if ((order_by && direction) || this.state.crimeTitle.length > 0) {
                this.setState({ is_sort: true });
              } else {
                this.setState({ is_sort: false });
              }
            });
        });
      }
      if (this.state.filter === "by_id") {
        twoPlusAction.get2PlusNewAropiPostBharaliList(obj).then((res) => {
          res &&
            res.text().then(async (text) => {
              const criminal = text && JSON.parse(text);
              let list = criminal.results;

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });
              this.setState({
                arophiList: tempObj,
                report4_API_loader: false,
                report4_List: list,
                total: list.length,
                report4_List1: list,
                report4_List_backup: list,
              });
              if ((order_by && direction) || this.state.crimeTitle.length > 0) {
                this.setState({ is_sort: true });
              } else {
                this.setState({ is_sort: false });
              }
            });
        });
      }
    }
  };
  get2lusNewListArophiCount = () => {
    const { report_4_startDate, report_4_endDate } = this.state;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const { user } = this.props;
    this.setState({
      report4_API_loader: true,
    });
    if (["4", "12"].includes(user.role)) {
      if (this.state.filter === "by_id") {
        let obj = {
          startDate: startDate,
          endDate: endDate,
          cityId:
            user.role === "12" ? this.state.selected_city : user && user.cityId,
        };
        twoPlusAction.get2lusNewListPostBharaliCount(obj).then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });
              let totalCrimeCount = columns1.reduce(
                (sum, res) => sum + (Number(res.crimeCount) || 0),
                0,
              );
              this.setState({
                arophiCount: tempObj,
                report4_API_loader: false,
                report4_List: list,
                report4_List1: list,
                total: totalCrimeCount,
              });
            });
        });
      }
      if (this.state.filter === "by_distinct") {
        let cityId =
          user.role === "12" ? this.state.selected_city : user && user.cityId;
        twoPlusAction
          .get2lusNewListArophiCount(startDate, endDate, cityId)
          .then((res) => {
            res &&
              res.text().then((criminalList1) => {
                let criminal = JSON.parse(criminalList1);
                let list = criminal.results;

                let columns1 =
                  list &&
                  list &&
                  list.map((itemObj, index) => {
                    return {
                      ...itemObj,
                    };
                  });

                let tempObj = columns1.map((res, index) => {
                  return {
                    ...res,
                  };
                });
                let totalCrimeCount = columns1.reduce(
                  (sum, res) => sum + (Number(res.crimeCount) || 0),
                  0,
                );
                this.setState({
                  arophiCount: tempObj,
                  report4_API_loader: false,
                  report4_List: list,
                  report4_List1: list,
                  total: totalCrimeCount,
                });
              });
          });
      }
    }
    if (user?.role === "9" || user?.role === "10") {
      if (this.state.filter === "by_distinct") {
        const temp = {
          startDate: startDate,
          endDate: endDate,
          districtId: user.map_districtId,
        };
        twoPlusAction.get2lusNewListArophiCountByRole(temp).then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let totalCrimeCount = columns1.reduce(
                (sum, res) => sum + (Number(res.crimeCount) || 0),
                0,
              );
              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });
              this.setState({
                arophiCount: tempObj,
                report4_API_loader: false,
                report4_List: list,
                report4_List1: list,
                total: totalCrimeCount,
              });
            });
        });
      }
      if (this.state.filter === "by_id") {
        const temp = {
          startDate: startDate,
          endDate: endDate,
          districtId: user.map_districtId,
        };
        twoPlusAction.get2lusNewListPostBharaliCountByRole(temp).then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });
              let totalCrimeCount = columns1.reduce(
                (sum, res) => sum + (Number(res.crimeCount) || 0),
                0,
              );

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });
              this.setState({
                arophiCount: tempObj,
                report4_API_loader: false,
                report4_List: list,
                report4_List1: list,
                total: totalCrimeCount,
              });
            });
        });
      }
    }
  };
  get2lusArophiListCount = () => {
    const {
      report_4_startDate,
      report_4_endDate,
      crimeTitle,
      order_by,
      direction,
    } = this.state;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const { user } = this.props;
    this.setState({
      report4_API_loader: true,
    });
    let obj = {
      startDate: startDate,
      endDate: endDate,
      cityId:
        user.role === "12" ? this.state.selected_city : user && user.cityId,
      heading: crimeTitle,
      order_by: order_by ? order_by : "",
      direction: direction ? direction : "",
    };
    let policeobj = {
      startDate: startDate,
      endDate: endDate,
      id: user && user.districtId,
      heading: crimeTitle,
      order_by: order_by ? order_by : "",
      direction: direction ? direction : "",
    };
    let districtobj = {
      startDate: startDate,
      endDate: endDate,
      districtId: user && user.map_districtId,
      heading: crimeTitle,
      order_by: order_by ? order_by : "",
      direction: direction ? direction : "",
    };
    if (user?.role === "2") {
      twoPlusAction
        .get2lusArophiListPoliceStationCount(policeobj)
        .then((res) => {
          res &&
            res.text().then(async (text) => {
              const criminal = text && JSON.parse(text);
              let list = criminal.results;

              let tempFilterData = _.filter(
                list && _.flatten(list),
                function (o) {
                  return Object.keys(o).length !== 0;
                },
              );
              tempFilterData = _.filter(
                tempFilterData && _.flatten(tempFilterData),
                function (item) {
                  return item.gunhaCount > 1;
                },
              );

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });

              this.setState({
                arophiListCount: tempObj,
                report4_API_loader: false,
                report4_List: tempObj,
                report4_List1: tempObj,
                total: tempObj.length,
                report4_List_backup: tempObj,
                arophiList: tempObj,
              });
            });
        });
    }
    if (user?.role == "9" || user?.role == "10") {
      if (this.state.filter === "by_distinct") {
        twoPlusAction.get2lusArophiListCountByRole(districtobj).then((res) => {
          res &&
            res.text().then(async (text) => {
              const criminal = text && JSON.parse(text);
              let list = criminal.results;

              let tempFilterData = _.filter(
                list && _.flatten(list),
                function (o) {
                  return Object.keys(o).length !== 0;
                },
              );
              tempFilterData = _.filter(
                tempFilterData && _.flatten(tempFilterData),
                function (item) {
                  return item.gunhaCount > 1;
                },
              );

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });

              this.setState({
                arophiListCount: tempObj,
                report4_API_loader: false,
                report4_List: tempObj,
                report4_List1: tempObj,
                total: tempObj.length,
                report4_List_backup: tempObj,
                arophiList: tempObj,
              });
              if ((order_by && direction) || this.state.crimeTitle.length > 0) {
                this.setState({
                  is_sort: true,
                });
              }
            });
        });
      }
      if (this.state.filter === "by_id") {
        twoPlusAction
          .get2lusArophiPostBharaliListByRole(districtobj)
          .then((res) => {
            res &&
              res.text().then(async (text) => {
                const criminal = text && JSON.parse(text);
                let list = criminal.results;

                let tempFilterData = _.filter(
                  list && _.flatten(list),
                  function (o) {
                    return Object.keys(o).length !== 0;
                  },
                );
                tempFilterData = _.filter(
                  tempFilterData && _.flatten(tempFilterData),
                  function (item) {
                    return item.gunhaCount > 1;
                  },
                );

                let columns1 =
                  list &&
                  list &&
                  list.map((itemObj, index) => {
                    return {
                      ...itemObj,
                    };
                  });

                let tempObj = columns1.map((res, index) => {
                  return {
                    ...res,
                  };
                });

                this.setState({
                  arophiListCount: tempObj,
                  report4_API_loader: false,
                  report4_List: tempObj,
                  report4_List1: tempObj,
                  total: tempObj.length,
                  report4_List_backup: tempObj,
                  arophiList: tempObj,
                });
                if (
                  (order_by && direction) ||
                  this.state.crimeTitle.length > 0
                ) {
                  this.setState({
                    is_sort: true,
                  });
                }
              });
          });
      }
    } else {
      if (this.state.filter === "by_distinct") {
        twoPlusAction.get2lusArophiListCount(obj).then((res) => {
          res &&
            res.text().then(async (text) => {
              const criminal = text && JSON.parse(text);
              let list = criminal.results;

              let tempFilterData = _.filter(
                list && _.flatten(list),
                function (o) {
                  return Object.keys(o).length !== 0;
                },
              );
              tempFilterData = _.filter(
                tempFilterData && _.flatten(tempFilterData),
                function (item) {
                  return item.gunhaCount > 1;
                },
              );

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });

              this.setState({
                arophiListCount: tempObj,
                report4_API_loader: false,
                report4_List: tempObj,
                report4_List1: tempObj,
                total: tempObj.length,
                report4_List_backup: tempObj,
                arophiList: tempObj,
              });
              if ((order_by && direction) || this.state.crimeTitle.length > 0) {
                this.setState({
                  is_sort: true,
                });
              }
            });
        });
      }
      if (this.state.filter === "by_id") {
        twoPlusAction.get2lusArophiPostBharaliList(obj).then((res) => {
          res &&
            res.text().then(async (text) => {
              const criminal = text && JSON.parse(text);
              let list = criminal.results;

              let tempFilterData = _.filter(
                list && _.flatten(list),
                function (o) {
                  return Object.keys(o).length !== 0;
                },
              );
              tempFilterData = _.filter(
                tempFilterData && _.flatten(tempFilterData),
                function (item) {
                  return item.gunhaCount > 1;
                },
              );

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });

              this.setState({
                arophiListCount: tempObj,
                report4_API_loader: false,
                report4_List: tempObj,
                report4_List1: tempObj,
                total: tempObj.length,
                report4_List_backup: tempObj,
                arophiList: tempObj,
              });
              if ((order_by && direction) || this.state.crimeTitle.length > 0) {
                this.setState({
                  is_sort: true,
                });
              }
            });
        });
      }
    }
  };

  getHistorySheeterCount = () => {
    const { user } = this.props;
    const { report_4_startDate, report_4_endDate } = this.state;

    const cityId = user && user.cityId;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const districtId = user && user.districtId;
    const temp = {
      cityId: user && user.cityId,
      startDate: startDate,
      endDate: endDate,
    };
    this.setState({
      report4_API_loader: true,
    });
    if (user?.role === "4") {
      twoPlusAction.getHistorySheeterCount(temp).then((res) => {
        res &&
          res.text().then(async (text) => {
            const criminal = text && JSON.parse(text);
            let list = criminal.results;

            let tempFilterData = _.filter(
              list && _.flatten(list),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });

            this.setState({
              historyCount: tempObj,
              report4_API_loader: false,
              report4_List1: tempObj,
            });
          });
      });
    }
    if (user?.role === "9" || user?.role === "10") {
      let obj = {
        districtId: user?.map_districtId,
        startDate: startDate,
        endDate: endDate,
      };
      twoPlusAction.getHistorySheeterCountByRole(obj).then((res) => {
        res &&
          res.text().then(async (text) => {
            const criminal = text && JSON.parse(text);
            let list = criminal.results;

            let tempFilterData = _.filter(
              list && _.flatten(list),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });

            this.setState({
              historyCount: tempObj,
              report4_API_loader: false,
              report4_List1: tempObj,
            });
          });
      });
    }
  };

  getHistorySheeterList = () => {
    const { user } = this.props;
    const {
      report_4_startDate,
      report_4_endDate,
      order_by,
      direction,
      crimeTitle,
    } = this.state;
    const cityId = user && user.cityId;
    const districtId = user && user.districtId;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    this.setState({
      report4_API_loader: true,
    });
    let districtobj = {
      districtId: user?.map_districtId,
    };
    if (user?.role === "2") {
      twoPlusAction.getHistorySheeterListPS(districtId).then((res) => {
        res &&
          res.text().then(async (text) => {
            const criminal = text && JSON.parse(text);
            let list = criminal.results;

            let tempFilterData = _.filter(
              list && _.flatten(list),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });

            this.setState({
              historyList: tempObj,
              report4_API_loader: false,
              report4_List: tempObj,
              total: tempObj.length,
            });
          });
      });
    }
    if (user?.role === "9" || user?.role === "10") {
      const temp = {
        districtId: user && user.map_districtId,
        startDate: startDate,
        endDate: endDate,
        order_by: order_by ? order_by : "",
        direction: direction ? direction : "",
      };
      twoPlusAction.getHistorySheeterListByRole(temp).then((res) => {
        res &&
          res.text().then(async (text) => {
            const criminal = text && JSON.parse(text);
            let list = criminal.results;

            let tempFilterData = _.filter(
              list && _.flatten(list),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });

            this.setState({
              historyList: tempObj,
              report4_API_loader: false,
              report4_List: tempObj,
              report4_List1: tempObj,
              total: tempObj.length,
            });
            if ((order_by && direction) || this.state.crimeTitle.length > 0) {
              this.setState({
                is_sort: true,
              });
            }
          });
      });
    } else {
      const temp = {
        district: this.state.districtIds,
        startDate: startDate,
        endDate: endDate,
        order_by: order_by ? order_by : "",
        direction: direction ? direction : "",
        heading: crimeTitle.length > 0 && crimeTitle,
      };
      twoPlusAction.getHistorySheeterList(temp).then((res) => {
        res &&
          res.text().then(async (text) => {
            const criminal = text && JSON.parse(text);
            let list = criminal.results;
            console.log("getHistorySheeterList", list);

            let tempFilterData = _.filter(
              list && _.flatten(list),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });

            this.setState({
              historyList: tempObj,
              report4_API_loader: false,
              report4_List: tempObj,
              report4_List1: tempObj,
              total: tempObj.length,
            });
            if ((order_by && direction) || this.state.crimeTitle.length > 0) {
              this.setState({
                is_sort: true,
              });
            }
          });
      });
    }
  };

  isSameDate(dates) {
    return (
      moment(dates[0]).isSame(dates[1], "day") &&
      moment(dates[0]).isSame(dates[1], "month") &&
      moment(dates[0]).isSame(dates[1], "year")
    );
  }
  getFormat(date) {
    if (isNaN(date)) {
      return moment(new Date(date).getTime(), "x").format("DD/MM/YY");
    } else {
      return moment(new Date().getTime(), "x").format("DD/MM/YY");
    }
  }

  isSameDateCompareWithData(compareDate, filterDate) {
    if (this.getFormat(compareDate) === this.getFormat(filterDate)) {
      return true;
    }
    return false;
  }

  getCityName = (id) => {
    if (Array.isArray(id)) {
      return id
        .map((cityId) => this.getCityName(cityId))
        .filter(Boolean)
        .join(", ");
    }
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  downloadReport1 = async () => {
    const { user } = this.props;
    var objDate = {
      startDate: this.state.report_4_startDate,
      endDate: this.state.report_4_endDate,
      cityId: user && user.cityId,
      heading: this.state.crimeTitle,
    };
    this.setState({
      report4_loader: true,
    });

    let DocumentComponent;

    if (this.state.report_type === "new arophi") {
      DocumentComponent = DocumentCount;
    } else if (
      (this.state.report_type == "arophi count" ||
        this.state.report_type == "history_sheeter") &&
      this.state.showList == "सांख्यिकी"
    ) {
      DocumentComponent = DocumentCount1;
    } else {
      DocumentComponent = Document9;
    }

    let name = "";
    const startDate = moment(this.state.report_4_startDate).format("DD/MM/YY");
    const endDate = moment(this.state.report_4_endDate).format("DD/MM/YY");
    if (this.state.report_type == "new arophi") {
      name = "आरोपी विरुद्ध नव्याने दाखल गुन्ह्याची आकडेवारी";
    } else if (this.state.report_type == "arophi_new_list") {
      name = "2 प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची यादी";
    } else if (
      this.state.report_type == "arophi count" &&
      this.state.showList == "सांख्यिकी"
    ) {
      name = "2 प्लस आरोपी - सांख्यिकी";
    } else if (
      this.state.report_type == "arophi count" &&
      this.state.showList == "यादी"
    ) {
      name = "2 प्लस आरोपी - यादी";
    } else if (
      this.state.report_type == "history_sheeter" &&
      this.state.showList == "यादी"
    ) {
      name = "हिस्ट्रीशिटर - यादी";
    } else if (
      this.state.report_type == "history_sheeter" &&
      this.state.showList == "सांख्यिकी"
    ) {
      name = "हिस्ट्रीशिटर - सांख्यिकी";
    } else {
      name = "2 प्लस आरोपी";
    }

    const blob = await pdf(
      <DocumentComponent
        rows={
          this.state.report_type === "new arophi"
            ? this.state.newArophiData
            : this.state.report_type == "arophi count" &&
                this.state.showList == "सांख्यिकी"
              ? this.state.arophiCount
              : this.state.report_type == "history_sheeter" &&
                  this.state.showList == "सांख्यिकी"
                ? this.state.report4_List1
                : this.state.report4_List
        }
        filterDate={
          this.state.report_type != "history_sheeter" ? objDate : null
        }
        allTotal={this.state.totalCriminal}
        total={this.state.report4_List_Total}
        cityName={this.getCityName(user && user.cityId)}
        report_name={name}
        user={user?.role}
        report_type={this.state.report_type}
      />,
    ).toBlob();

    if (blob) {
      this.setState({
        report4_loader: false,
      });

      let fileName = name;

      if (this.state.report_type != "history_sheeter") {
        fileName += ` ${startDate} to ${endDate}`;
      }

      saveAs(blob, fileName);

      // saveAs(blob, name + " " + startDate + "to" + endDate);
    }
  };

  isloading = () => {
    this.setState({ loading: true });
  };

  isNotloading = () => {
    this.setState({ loading: false });
  };

  generatePDFReport1 = async () => {
    const { user } = this.props;
    let obj = {
      startDate: this.state.report_4_startDate,
      endDate: this.state.report_4_endDate,
      cityId: user && user.cityId,
      heading: this.state.crimeTitle,
    };
    let policeobj = {
      startDate: this.state.report_4_startDate,
      endDate: this.state.report_4_endDate,
      id: user && user.districtId,
      heading: this.state.crimeTitle,
    };
    this.setState({
      report4_API_loader: true,
    });
    if (user?.role === "2") {
      professionalAction.getPoliceStation2PlusReports(policeobj).then((res) => {
        res &&
          res &&
          res.text().then(async (text) => {
            const tempData = text && JSON.parse(text);
            let tempFilterData = _.filter(
              tempData && _.flatten(tempData),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );
            this.setState({
              report4_API_loader: false,
              report4_List: tempFilterData,
            });
          });
      });
    } else {
      professionalAction.get2PlusReports(obj).then((res) => {
        res &&
          res &&
          res.text().then(async (text) => {
            const tempData = text && JSON.parse(text);
            let tempFilterData = _.filter(
              tempData && _.flatten(tempData),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );
            this.setState({
              report4_API_loader: false,
              report4_List: tempFilterData,
            });
          });
      });
    }
  };

  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.toISOString();

      this.setState({
        report_4_startDate: startDate,
        report_4_endDate: null, // reset end date when start changes
        isMoreThanOneYear: false,
      });
    } else {
      this.setState({
        report_4_startDate: null,
        report_4_endDate: null,
        isMoreThanOneYear: false,
      });
    }
  };

  onEndDateChange = (date) => {
    if (!date) return;

    const { report_4_startDate } = this.state;

    this.setState(
      {
        report_4_endDate: date.toISOString(),
      },
      () => {
        if (report_4_startDate) {
          const start = moment(report_4_startDate);
          const end = moment(date);

          if (end.diff(start, "years", true) > 5) {
            message.warning("Date range cannot be more than 5 year!");
            this.setState({ isMoreThanOneYear: true });
          } else {
            this.setState({ isMoreThanOneYear: false });
          }
        }
      },
    );
  };

  disabledEndDate = (current) => {
    const { report_4_startDate } = this.state;
    if (!report_4_startDate) return false;

    const start = moment(report_4_startDate).startOf("day");
    return current.isBefore(start, "day"); // block anything before start date
  };

  onViewAccusedForm = (data) => {
    if (data) {
      let obj = {
        startDate: this.state.report_4_startDate,
        endDate: this.state.report_4_endDate,
        id: data,
        heading: this.state.crimeTitle,
      };
      this.props.dispatch(professionalAction.get2PlusCriminalsViewsById(obj));
      this.showCriminalViewModel();
    }
  };

  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };

  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };

  selectReportType = (value) => {
    this.setState(
      {
        report_type: value,
        total: "",
        showList: "सांख्यिकी",
        activeMainTab: "list",
        is_sort: false,
        showFilterSection: false,
        order_by: "",
        direction: "",
        crimeTitle: [],
        selectedPreventiveStatuses: [],
      },
      () => {},
    );
    this.setState({
      report4_List: [],
      report4_List1: [],
      arophiCount: [],
      historyCount: [],
      historyList: [],
      newArophiData: [],
      arophiListCount: [],
      arophiList: [],
    });
  };

  get2lusArophiCount = () => {
    const { report_4_startDate, report_4_endDate } = this.state;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const { user } = this.props;
    if (user?.role === "2") {
      TwoPlusService.get2lusNewArophiPoliceStationCount(
        startDate,
        endDate,
        user?.districtId,
      ).then((res) => {});
    } else {
      TwoPlusService.get2lusArophiCount(startDate, endDate, user?.cityId).then(
        (res) => {},
      );
    }
  };
  download_csv1 = () => {
    const { t, language } = this.context;
    const { showList, filter } = this.state;
    const report_name =
      this.state.report_type === "new arophi"
        ? t("accused_new_cases_statistics")
        : this.state.report_type === "arophi count" &&
            this.state.showList === "सांख्यिकी"
          ? t("two_plus_accused")
          : this.state.report_type === "arophi_new_list"
            ? t("two_plus_accused_list")
            : this.state.report_type === "history_sheeter"
              ? t("history")
              : this.state.report_type == "more_than_two_plus_list"
                ? t("accused_combined_list_2_plus")
                : t("two_plus_accused");
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;

    let ReportTitle = "";

    if (this.state.report_type === "new arophi") {
      ReportTitle = t("accused_new_cases_statistics");
    } else if (
      this.state.report_type === "arophi count" &&
      this.state.showList === "सांख्यिकी"
    ) {
      ReportTitle = `${t("two_plus_accused")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : `${t("data_entered_by_police_station1")} - ${t("statistics1")}`
      }`;
    } else if (this.state.report_type === "arophi_new_list") {
      ReportTitle = `${t("two_plus_accused_list")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : t("data_entered_by_police_station1")
      }`;
    } else if (this.state.report_type === "more_than_two_plus_list") {
      ReportTitle = `${t("accused_combined_list_2_plus")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : t("data_entered_by_police_station1")
      }`;
    } else if (this.state.report_type === "history_sheeter") {
      ReportTitle = `${t("history")} - ${
        this.state.showList === "सांख्यिकी" ? t("statistics1") : t("list")
      }`;
    } else {
      ReportTitle = `${t("two_plus_accused")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : t("data_entered_by_police_station1")
      }`;
    }

    let list = [];
    const data = this.applyListViewToExport(
      this.state.report_type === "arophi_new_list"
        ? this.state.arophiListCount
        : this.state.report4_List,
    );
    console.log("data", data);
    list =
      this.state.report_type == "history_sheeter"
        ? data &&
          data.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("name")]: data.name ? data.name : "-",
            [t("address")]: data.address ? data.address : "-",
            [t("age")]: data.age ? data.age : "-",
            [t("history_sheeter_entry_date")]: data.history_date
              ? moment(data.history_date).format("DD-MM-YYYY")
              : "-",
            [t("accused_police_station")]: data.districtName
              ? data.districtName
              : "-",
            [t("total_crimes ")]: data.totalCrimeCount
              ? data.totalCrimeCount
              : "-",
            [t("photo")]: data.photo ? t("yes") : t("no"),
            [t("preventive_action")]: (() => {
              if (
                !data.prevetive_record ||
                data.prevetive_record.length === 0
              ) {
                return "-";
              }

              const firstRecord = data.prevetive_record[0];

              if (!firstRecord.date_to) {
                return "-";
              }

              return moment(firstRecord.date_to).isBefore(moment(), "day")
                ? t("completed")
                : t("ongoing");
            })(),
          }))
        : data &&
          data.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("accused_police_station")]: data.districtName
              ? data.districtName
              : data.crime_districtName
                ? data.crime_districtName
                : "-",
            [t("name")]: data.name ? data.name : "-",
            [t("address")]: data.address ? data.address : "-",
            [t("total_crimes")]: data.totalCrimeCount
              ? data.totalCrimeCount
              : "-",
            "शेवटचा गुन्ह्याचे पो. स्टे": data.last_districtName
              ? data.last_districtName
              : "-",
            [t("title")]: data?.gunha_records?.length
              ? data?.gunha_records[data.gunha_records.length - 1].crime_title
              : "",
            [t("cr_no_datetime")]: `${data.cr_no ? data.cr_no : "-"} - ${
              data.guna_date ? data.guna_date : "-"
            }`,
            [t("photo")]: data.photo ? t("yes") : t("no"),
            [t("action_type")]:
              data?.prevetive_records?.at(-1)?.preventive_action_name || "-",
            [t("preventive_action")]: (() => {
              if (
                !data.prevetive_records ||
                data.prevetive_records.length === 0
              ) {
                return "-";
              }

              const firstRecord = data.prevetive_records[0];

              if (!firstRecord.date_to) {
                return "-";
              }

              return moment(firstRecord.date_to).isBefore(moment(), "day")
                ? t("completed")
                : t("ongoing");
            })(),
            [t("start_date")]: data?.prevetive_records?.at(-1)?.date_from
              ? moment(data.prevetive_records.at(-1).date_from).format(
                  "DD-MM-YYYY",
                )
              : "-",

            [t("end_date")]: data?.prevetive_records?.at(-1)?.date_to
              ? moment(data.prevetive_records.at(-1).date_to).format(
                  "DD-MM-YYYY",
                )
              : "-",
          }));
    console.log("final list", list);
    let list2 = [];
    list2 =
      this.state.report_type === "new arophi"
        ? this.state.report4_List1 &&
          this.state.report4_List1 &&
          this.state.report4_List1.map((data, index) => {
            const मालाविषयक = parseInt(data["मालाविषयक"]) || 0;
            const शरीराविषयक = parseInt(data["शरीराविषयक"]) || 0;
            const अवैध_वाळू_विषयक = parseInt(data["अवैध वाळू विषयक"]) || 0;
            const अवैध_दारु_विषयक = parseInt(data["अवैध दारु विषयक"]) || 0;
            const जुगारविषयक = parseInt(data["जुगारविषयक"]) || 0;
            const भाग_६ = parseInt(data["भाग - ६"]) || 0;
            const इतर = parseInt(data["भाग - ६"]) || 0;

            const total =
              मालाविषयक +
              शरीराविषयक +
              अवैध_वाळू_विषयक +
              अवैध_दारु_विषयक +
              जुगारविषयक +
              भाग_६ +
              इतर;

            return {
              [t("sr.no")]: index + 1,
              [t("crime_police_station")]: data.districtName,
              [t("body_offender")]: शरीराविषयक,
              [t("property_offender")]: मालाविषयक,
              [t("illegal_sand_transportation")]: अवैध_वाळू_विषयक,
              [t("illegal_liquor_related")]: अवैध_दारु_विषयक,
              [t("gambling_related")]: जुगारविषयक,
              [t("section_6")]: भाग_६,
              [t("other_crimes")]: इतर,
              [t("total")]: total,
            };
          })
        : this.state.report_type === "history_sheeter"
          ? this.state.report4_List1 &&
            this.state.report4_List1.map((data, index) => {
              return {
                [t("sr.no")]: index + 1,
                [t("police_station")]: data.districtName,
                [t("history_sheeter_statistics")]: data.Count_district,
              };
            })
          : this.state.report4_List1 &&
            this.state.report4_List1.map((data, index) => {
              return {
                [t("sr.no")]: index + 1,
                [t("police_station")]: data.districtName,
                [t("2_plus_statistics")]: data.crimeCount,
              };
            });
    console.log("showList", showList);
    var arrData =
      showList === "सांख्यिकी" || this.state.report_type == "new arophi"
        ? list2
        : list;
    console.log("arrData", arrData);

    if (!arrData || !arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName =
      this.props.user.role === "12"
        ? this.getCityName(this.state.selected_city)
        : this.getCityName(this.props?.user?.cityId || "");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `From: ${
        moment(this.state.report_4_startDate).format("DD-MM-YYYY") || "-"
      } To ${moment(this.state.report_4_endDate).format("DD-MM-YYYY") || "-"}`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  // download_csv = () => {
  //   const { t, language } = this.context;
  //   const { filter } = this.state;
  //   const report_name =
  //     this.state.report_type === "new arophi"
  //       ? t("accused_new_cases_statistics")
  //       : this.state.report_type === "arophi count" &&
  //         this.state.showList === "सांख्यिकी"
  //       ? t("two_plus_accused")
  //       : this.state.report_type === "arophi_new_list"
  //       ? t("two_plus_accused_list")
  //       : t("two_plus_accused");
  //   const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;

  //   let ReportTitle = "";

  //   if (this.state.report_type === "new arophi") {
  //     ReportTitle = t("accused_new_cases_statistics");
  //   } else if (
  //     this.state.report_type === "arophi count" &&
  //     this.state.showList === "सांख्यिकी"
  //   ) {
  //     ReportTitle = `${t("two_plus_accused")} - ${
  //       filter === "by_distinct"
  //         ? t("info_within_police_station_limits")
  //         : `${t("data_entered_by_police_station")} - ${t("statistics1")}`
  //     }`;
  //   } else if (this.state.report_type === "arophi_new_list") {
  //     ReportTitle = `${t("two_plus_accused_list")} - ${
  //       filter === "by_distinct"
  //         ? t("info_within_police_station_crime")
  //         : t("data_entered_by_police_crime")
  //     }`;
  //   } else {
  //     ReportTitle = `${t("two_plus_accused")} - ${
  //       filter === "by_distinct"
  //         ? t("info_within_police_station_limits")
  //         : t("data_entered_by_police_station")
  //     }`;
  //   }

  //   const headerStyle = {
  //     font: { bold: true, sz: 14, color: { rgb: "000000" } },
  //     alignment: { horizontal: "center", vertical: "center", wrapText: true },
  //     border: {
  //       top: { style: "thin", color: { rgb: "000000" } },
  //       bottom: { style: "thin", color: { rgb: "000000" } },
  //       left: { style: "thin", color: { rgb: "000000" } },
  //       right: { style: "thin", color: { rgb: "000000" } },
  //     },
  //   };

  //   const wb = XLSX.utils.book_new();
  //   const ws = XLSX.utils.aoa_to_sheet([]);
  //   const totalCols = 15; // Adjusted for removed columns
  //   let merges = [];
  //   const cityName = this.getCityName(this.props?.user?.cityId || "");
  //   const headerData = `(${cityName})`;
  //   // City Name
  //   XLSX.utils.sheet_add_aoa(ws, [[headerData]], { origin: "A1" });
  //   ws["A1"].s = headerStyle;
  //   merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

  //   // Report Title
  //   XLSX.utils.sheet_add_aoa(ws, [[ReportTitle]], { origin: "A2" });
  //   ws["A2"].s = headerStyle;
  //   merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

  //   // Date Range
  //   XLSX.utils.sheet_add_aoa(
  //     ws,
  //     [
  //       [
  //         `${t("from")} ${moment(this.state.report_4_startDate).format(
  //           "DD-MM-YYYY"
  //         )} - ${t("to")} ${moment(this.state.report_4_endDate).format(
  //           "DD-MM-YYYY"
  //         )}`,
  //       ],
  //     ],
  //     { origin: "A3" }
  //   );
  //   ws["A3"].s = headerStyle;
  //   merges.push({ s: { r: 2, c: 0 }, e: { r: 2, c: totalCols - 1 } });

  //   // Define column headers
  //   const currentStatusLabel = `${t("current_status")}(${moment().format(
  //     "DD-MM-YYYY"
  //   )})`;

  //   const headers = [
  //     t("sr.no"),
  //     t("accused_police_station"),
  //     t("name"),
  //     t("total_crimes"),
  //     t("photo"),
  //     t("title"),
  //     t("crime_police_station"),
  //     t("crime_register_number"),
  //     t("crime_register_year"),
  //     t("crime_registration_date"),
  //     t("law_and_section"),
  //     t("preventive_action"),
  //     currentStatusLabel,
  //     t("date_from"),
  //     t("date_to"),
  //   ];

  //   const ws_data = [headers];

  //   let rowIndex = 4;

  //   // Process report data
  //   const reportData = this.state.report4_List;
  //   const accusedFixedCols = 5; // Adjusted for removed columns
  //   reportData.forEach((accused, idx) => {
  //     const gunhas = accused.gunha_records?.length ? accused.gunha_records : [];
  //     gunhas.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime));
  //     const preventive_actions = accused.prevetive_records?.length
  //       ? accused.prevetive_records
  //       : [];
  //     const rowspan = gunhas.length + preventive_actions.length;

  //     // Process gunha_records (crime records) first
  //     gunhas.forEach((gunha, gIndex) => {
  //       const row = [];
  //       if (gIndex === 0) {
  //         row.push(idx + 1);
  //         row.push(accused.districtName || accused.crime_districtName);
  //         row.push(accused.name || "-");
  //         row.push(accused.totalCrimeCount || "-");
  //         row.push(
  //           accused.photo?.length && accused.photo[0] !== "" ? "Yes" : "No"
  //         );
  //       } else {
  //         for (let i = 0; i < accusedFixedCols; i++) row.push("");
  //       }

  //       row.push(gunha.crime_title || "-");
  //       row.push(gunha.districtName || "-");
  //       row.push(gunha.registernumber || "-");
  //       row.push(moment(gunha.registernumberYear).format("YYYY") || "-");
  //       row.push(moment(gunha.dateTime).format("DD/MM/YYYY") || "-");

  //       // Law and Section
  //       let lawData = "";
  //       if (gunha.kk_info && gunha.kk_info.length > 0) {
  //         const grouped = {};
  //         gunha.kk_info.forEach((rule) => {
  //           const name = rule.rulesName || "-";
  //           const kalma = rule.kalam || "-";
  //           if (!grouped[name]) {
  //             grouped[name] = [kalma];
  //           } else if (!grouped[name].includes(kalma)) {
  //             grouped[name].push(kalma);
  //           }
  //         });
  //         lawData = Object.entries(grouped)
  //           .map(([name, kalmas]) => `${name}: ${kalmas.join(", ")}`)
  //           .join("\n");
  //       }
  //       row.push(lawData);

  //       // Leave preventive action fields blank for gunha records
  //       row.push(""); // preventive_action
  //       row.push(""); // current_status
  //       row.push(""); // date_from
  //       row.push(""); // date_to

  //       ws_data.push(row);
  //     });

  //     // Process preventive_action records after gunha_records
  //     preventive_actions.forEach((action, aIndex) => {
  //       const row = [];
  //       if (aIndex === 0 && gunhas.length === 0) {
  //         row.push(idx + 1);
  //         row.push(accused.districtName || accused.crime_districtName);
  //         row.push(accused.name || "-");
  //         row.push(accused.totalCrimeCount || "-");
  //         row.push(
  //           accused.photo?.length && accused.photo[0] !== "" ? "Yes" : "No"
  //         );
  //       } else {
  //         for (let i = 0; i < accusedFixedCols; i++) row.push("");
  //       }

  //       // Leave crime-related fields blank for preventive actions
  //       row.push(""); // title
  //       row.push(""); // crime_police_station
  //       row.push(""); // crime_register_number
  //       row.push(""); // crime_register_year
  //       row.push(""); // crime_registration_date
  //       row.push(""); // law_and_section

  //       // Preventive action fields
  //       row.push(action.preventive_action_name || "");
  //       // Current Status
  //       const currentDate = moment();
  //       const dateTo = action.date_to ? moment(action.date_to) : null;
  //       const status = action.date_to
  //         ? dateTo.isBefore(currentDate, "day")
  //           ? t("completed")
  //           : t("ongoing")
  //         : "";
  //       row.push(status);
  //       row.push(
  //         action.date_from ? moment(action.date_from).format("DD-MM-YYYY") : ""
  //       ); // date_from
  //       row.push(
  //         action.date_to ? moment(action.date_to).format("DD-MM-YYYY") : ""
  //       ); // date_to

  //       ws_data.push(row);
  //     });

  //     // Add merges for accused details if rowspan > 1
  //     if (rowspan > 1) {
  //       const accusedColsEnd = 4; // Adjusted for removed columns
  //       for (let col = 0; col <= accusedColsEnd; col++) {
  //         merges.push({
  //           s: { r: rowIndex, c: col },
  //           e: { r: rowIndex + rowspan - 1, c: col },
  //         });
  //       }
  //     }

  //     rowIndex += rowspan;
  //   });

  //   // Add footer
  //   const footerContent = `Generated At ${moment(new Date()).format(
  //     "DD MMM YYYY"
  //   )} From Criminal Monitoring Intelligent System`;
  //   const footerRowIndex = rowIndex + 2;
  //   XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
  //     origin: `A${footerRowIndex}`,
  //   });
  //   ws[`A${footerRowIndex}`].s = {
  //     font: { bold: true, sz: 12, color: { rgb: "000000" } },
  //     alignment: { horizontal: "center", vertical: "center", wrapText: true },
  //     border: {
  //       top: { style: "thin", color: { rgb: "000000" } },
  //       bottom: { style: "thin", color: { rgb: "000000" } },
  //       left: { style: "thin", color: { rgb: "000000" } },
  //       right: { style: "thin", color: { rgb: "000000" } },
  //     },
  //   };
  //   merges.push({
  //     s: { r: footerRowIndex - 1, c: 0 },
  //     e: { r: footerRowIndex - 1, c: totalCols - 1 },
  //   });

  //   // Add data rows
  //   XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: "A4" });
  //   ws["!merges"] = merges;

  //   // Auto column width
  //   const columnWidths = ws_data[0].map((_, colIndex) => ({
  //     wch:
  //       Math.max(
  //         ...ws_data.map((row) =>
  //           row[colIndex]
  //             ? row[colIndex]
  //                 .toString()
  //                 .split("\n")
  //                 .reduce((max, line) => Math.max(max, line.length), 0)
  //             : 0
  //         )
  //       ) + 6,
  //   }));
  //   ws["!cols"] = columnWidths;

  //   // Adjust row heights
  //   const lawColIndex = 10; // Adjusted for removed columns
  //   ws["!rows"] = ws_data.map((row, idx) => {
  //     if (idx === 0) return { hpt: 25 };
  //     const lawDataCell = row[lawColIndex] || "";
  //     const lineCount = lawDataCell.toString().split("\n").length;
  //     return { hpt: Math.max(25, lineCount * 20) };
  //   });
  //   ws["!rows"].unshift({ hpt: 30 }); // Date Range
  //   ws["!rows"].unshift({ hpt: 30 }); // Report Title
  //   ws["!rows"].unshift({ hpt: 30 }); // City Name

  //   XLSX.utils.book_append_sheet(wb, ws, "Report");
  //   XLSX.writeFile(wb, `${file_name}.xlsx`);
  // };

  download_csv = () => {
    const { t, language } = this.context;
    const { filter } = this.state;
    const { user, report4_List } = this.state;
    const criminalList = this.applyListViewToExport(report4_List);
    if (!criminalList.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }
    const report_name =
      this.state.report_type === "new arophi"
        ? t("accused_new_cases_statistics")
        : this.state.report_type === "arophi count" &&
            this.state.showList === "सांख्यिकी"
          ? t("two_plus_accused")
          : this.state.report_type === "arophi_new_list"
            ? t("two_plus_accused_list")
            : this.state.report_type == "more_than_two_plus_list"
              ? t("accused_combined_list_2_plus")
              : t("two_plus_accused");
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;

    let ReportTitle = "";

    if (this.state.report_type === "new arophi") {
      ReportTitle = t("accused_new_cases_statistics");
    } else if (
      this.state.report_type === "arophi count" &&
      this.state.showList === "सांख्यिकी"
    ) {
      ReportTitle = `${t("two_plus_accused")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits")
          : `${t("data_entered_by_police_station")} - ${t("statistics1")}`
      }`;
    } else if (this.state.report_type === "arophi_new_list") {
      ReportTitle = `${t("two_plus_accused_list")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_crime")
          : t("data_entered_by_police_crime")
      }`;
    } else if (this.state.report_type === "more_than_two_plus_list") {
      ReportTitle = `${t("accused_combined_list_2_plus")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_crime")
          : t("data_entered_by_police_crime")
      }`;
    } else {
      ReportTitle = `${t("two_plus_accused")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits")
          : t("data_entered_by_police_station")
      }`;
    }

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      // alignment: { vertical: "top", wrapText: true },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    /* ===================== WORKBOOK ===================== */

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const merges = [];
    const totalCols = 16;

    const cityName =
      this.props.user.role === "12"
        ? this.getCityName(this.state.selected_city)
        : this.getCityName(this.props?.user?.cityId || "");
    console.log("city name", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;
    const dateRange = `${t("from")} ${moment(
      this.state.report_4_startDate,
    ).format("DD-MM-YYYY")} - ${t("to")} ${moment(
      this.state.report_4_endDate,
    ).format("DD-MM-YYYY")}`;

    /* ===================== TITLES ===================== */

    XLSX.utils.sheet_add_aoa(ws, [[cityName]], {
      origin: "A1",
    });
    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[ReportTitle]], { origin: "A2" });
    ws["A2"].s = subTitleStyle;
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[dateRange]], { origin: "A3" });
    ws["A3"].s = subTitleStyle;
    merges.push({ s: { r: 2, c: 0 }, e: { r: 2, c: totalCols - 1 } });

    /* ===================== HEADERS ===================== */

    const currentStatusLabel = `${t("current_status")} (${moment().format(
      "DD-MM-YYYY",
    )})`;

    const headers = [
      t("sr.no"),
      t("accused_police_station"),
      t("name"),
      t("address"),
      t("total_crimes"),
      t("photo"),
      t("title"),
      t("crime_police_station"),
      t("crime_register_number"),
      t("crime_register_year"),
      t("crime_registration_date"),
      t("law_and_section"),
      t("preventive_action"),
      currentStatusLabel,
      t("date_from"),
      t("date_to"),
    ];

    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A4" });
    headers.forEach((_, c) => {
      ws[XLSX.utils.encode_cell({ r: 3, c })].s = headerStyle;
    });

    /* ===================== DATA (FIXED) ===================== */

    const ws_data = [];
    const accusedFixedCols = 6;

    criminalList.forEach((accused, idx) => {
      const gunhas = (accused.gunha_records || []).sort(
        (a, b) => new Date(b.dateTime) - new Date(a.dateTime),
      );

      const preventive = accused.prevetive_records || [];

      const maxRows = Math.max(gunhas.length, preventive.length, 1);

      for (let i = 0; i < maxRows; i++) {
        const row = [];

        /* ACCUSED */
        if (i === 0) {
          row.push(
            idx + 1,
            accused.districtName || accused.crime_districtName || "-",
            accused.name || "-",
            accused.address || "-",
            accused.totalCrimeCount || "-",
            accused.photo?.length && accused.photo[0] !== "" ? "Yes" : "No",
          );
        } else {
          for (let k = 0; k < accusedFixedCols; k++) row.push("");
        }

        /* GUNHA */
        const gunha = gunhas[i];
        if (gunha) {
          row.push(
            gunha.crime_title || "-",
            gunha.districtName || "-",
            gunha.registernumber || "-",
            gunha.registernumberYear
              ? moment(gunha.registernumberYear).format("YYYY")
              : "-",
            gunha.dateTime ? moment(gunha.dateTime).format("DD/MM/YYYY") : "-",
          );

          let lawData = "-";
          if (gunha.kk_info?.length) {
            const grouped = {};
            gunha.kk_info.forEach((r) => {
              const name = r.rulesName || "-";
              const kalma = r.kalam || "-";
              grouped[name] = grouped[name]
                ? Array.from(new Set([...grouped[name], kalma]))
                : [kalma];
            });
            lawData = Object.entries(grouped)
              .map(([n, k]) => `${n}: ${k.join(", ")}`)
              .join("\n");
          }
          row.push(lawData);
        } else {
          row.push("", "", "", "", "", "");
        }

        /* PREVENTIVE */
        const action = preventive[i];
        if (action) {
          row.push(
            action.preventive_action_name || "-",
            action.date_to && moment(action.date_to).isBefore(moment(), "day")
              ? t("completed")
              : t("ongoing"),
            action.date_from
              ? moment(action.date_from).format("DD-MM-YYYY")
              : "-",
            action.date_to ? moment(action.date_to).format("DD-MM-YYYY") : "-",
          );
        } else {
          row.push("", "", "", "");
        }

        ws_data.push(row);
      }
    });

    XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: "A5" });

    ws_data.forEach((row, r) =>
      row.forEach((_, c) => {
        const cell = XLSX.utils.encode_cell({ r: r + 4, c });
        if (ws[cell]) ws[cell].s = cellStyle;
      }),
    );

    const footerRowIndex = ws_data.length + 6;

    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });

    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });
    /* ===================== WIDTH / HEIGHT ===================== */

    ws["!cols"] = [
      { wch: 6 },
      { wch: 18 },
      { wch: 18 },
      { wch: 28 },
      { wch: 12 },
      { wch: 8 },
      { wch: 18 },
      { wch: 18 },
      { wch: 16 },
      { wch: 14 },
      { wch: 16 },
      { wch: 36 },
      { wch: 22 },
      { wch: 18 },
      { wch: 14 },
      { wch: 14 },
    ];

    ws["!rows"] = [{ hpt: 38 }, { hpt: 30 }, { hpt: 28 }, { hpt: 42 }];

    for (let i = 4; i < ws_data.length + 4; i++) {
      ws["!rows"][i] = { hpt: 44 };
    }
    ws["!rows"][footerRowIndex - 1] = { hpt: 28 };
    ws["!freeze"] = { ySplit: 4 };
    ws["!merges"] = merges;

    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  sortby = (name, direction) => {
    this.setState({
      order_by: name,
      direction: direction,
    });
  };

  handleTableSortChange = (sortInfo) => {
    this.setState({
      tableSort: {
        field: sortInfo?.field || "",
        order: sortInfo?.order || "",
      },
    });
  };

  handleDistrictFilterChange = (districts) => {
    this.setState({
      selectedLastDistricts: districts || [],
    });
  };

  handlePreventiveFilterChange = (statuses) => {
    this.setState({
      selectedPreventiveStatuses: statuses || [],
    });
  };

  handleVisibleRowsChange = (ids) => {
    const current = this.state.visibleExportIds;
    const same =
      current === ids ||
      (current == null && ids == null) ||
      (Array.isArray(current) &&
        Array.isArray(ids) &&
        current.length === ids.length &&
        current.every((id, index) => String(id) === String(ids[index])));
    if (same) return;
    this.setState({ visibleExportIds: ids });
  };

  filterkey = (e) => {
    this.setState({ key: e.key });
  };
  clearFilter = () => {
    if (this.state.crimeTitle.length > 0) {
      this.setState(
        {
          crimeTitle: [],
          is_sort: false,
          report4_List: [],
          report4_List1: [],
          key: "",
          order_by: "",
          direction: "",
          advancedFilterPhoto: "all",
        },
        () => {
          this.getData(); // Call getData after state is reset
        },
      );
    } else {
      this.setState(
        {
          crimeTitle: [],
          is_sort: false,
          report4_List: [],
          report4_List1: [],
          key: "",
          order_by: "",
          direction: "",
        },
        () => {
          this.getData(); // Call getData after state is reset
        },
      );
    }
  };
  componentDidMount = () => {
    if (!this.props.professionals?.pc_crimetitles) {
      this.props.dispatch(professionalAction.getCrimeTitle());
    }
    const { user } = this.props;
    if (user && user.role !== "4" && user.role !== "12") {
      this.setState({ showList: "यादी" });
    }
    this.getPreventiveInfo();
    this.onCityChange();
    this.props.dispatch(professionalAction.getCity());
    if (user && user.role === "12") {
      this.userMapCityDetails();
    }
  };
  handleAdvancedFilterPhotoChange = (e) => {
    const value = e.target.value;
    this.setState({ advancedFilterPhoto: value });

    const { report4_List_backup, report4_List } = this.state; // keep original data safe

    let filtered;

    if (value === "yes") {
      filtered = report4_List_backup.filter(
        (item) =>
          item.photo !== null && item.photo !== "" && item.photo !== undefined,
      );
    } else if (value === "no") {
      filtered = report4_List_backup.filter(
        (item) =>
          item.photo === null || item.photo === "" || item.photo === undefined,
      );
    } else {
      filtered = report4_List_backup;
    }

    this.setState({
      report4_List: filtered,
      total: filtered.length,
      arophiList: filtered,
      arophiCount: filtered,
      arophiListCount: filtered,
      newArophiData: filtered,
    });
  };
  render() {
    console.log("this.props two", this.props);
    const {
      report_4_startDate,
      report_4_endDate,
      key,
      direction,
      order_by,
      preventiveAction,
      mapped_cities,
    } = this.state;
    const { users } = this.props;
    const { user } = this.props;
    const { professionals } = this.props;
    console.log("direction", direction, direction);
    const { pc_cities, loading, pc_crimetitles, basicDistricts } =
      professionals;

    const { language, t } = this.context;
    const menu = (
      <Menu onClick={this.filterkey} style={{ width: "200px", padding: "8px" }}>
        <Menu.Item key="name">
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {t("sort_by_name")}

            <ArrowUpOutlined
              title="ASC"
              style={{
                color:
                  key === "name" && direction === "ASC" ? "#1890ff" : "#bfbfbf",
              }}
              onClick={() => this.sortby("name", "ASC")} // Toggle to ASC on click
            />
            <ArrowDownOutlined
              title="DESC"
              style={{
                color:
                  key === "name" && direction === "DESC"
                    ? "#1890ff"
                    : "#bfbfbf",
              }}
              onClick={() => this.sortby("name", "DESC")} // Toggle to DESC on click
            />
          </div>
        </Menu.Item>

        <>
          <Menu.Item key="districtName">
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {this.props.users && this.props.users.role === "2"
                ? t("sort_by_police_station")
                : t("sort_by_district_name")}

              <ArrowUpOutlined
                title="ASC"
                style={{
                  color:
                    key === "districtName" && direction === "ASC"
                      ? "#1890ff"
                      : "#bfbfbf",
                }}
                onClick={() => this.sortby("districtName", "ASC")} // Toggle to ASC
              />
              <ArrowDownOutlined
                title="DESC"
                style={{
                  color:
                    key === "districtName" && direction === "DESC"
                      ? "#1890ff"
                      : "#bfbfbf",
                }}
                onClick={() => this.sortby("districtName", "DESC")} // Toggle to DESC
              />
            </div>
          </Menu.Item>

          <Menu.Item key="totalCrimeCount">
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {t("sort_by_total_crimes")}

              <ArrowUpOutlined
                title="ASC"
                style={{
                  color:
                    key === "totalCrimeCount" && direction === "ASC"
                      ? "#1890ff"
                      : "#bfbfbf",
                }}
                onClick={() => this.sortby("totalCrimeCount", "ASC")} // Toggle to ASC
              />
              <ArrowDownOutlined
                title="DESC"
                style={{
                  color:
                    key === "totalCrimeCount" && direction === "DESC"
                      ? "#1890ff"
                      : "#bfbfbf",
                }}
                onClick={() => this.sortby("totalCrimeCount", "DESC")} // Toggle to DESC
              />
            </div>
          </Menu.Item>
        </>
      </Menu>
    );
    console.log("this.myTableRef.current", this.myTableRef.current);
    const isGraphTab = this.state.activeMainTab === "graph";
    const reportStartDate = isGraphTab
      ? this.state.graphAppliedStartDate
      : report_4_startDate;
    const reportEndDate = isGraphTab
      ? this.state.graphAppliedEndDate
      : report_4_endDate;
    const reportShowList = isGraphTab ? "graph" : this.state.showList;
    return (
      <>
        <Spin spinning={this.state.loading} delay={500}>
          <div className="col-md-6 col-md-offset-3">
            <div className="site-page-header-ghost-wrapper">
              <PageHeader
                className="site-page-header"
                ghost={false}
                onBack={false}
              >
                {this.props.user.role === "12" && (
                  <Form.Item
                    name="selected_city"
                    label="City"
                    labelCol={{ style: { whiteSpace: "nowrap" } }}
                    style={{ width: "100%" }}
                  >
                    <Select
                      mode="multiple"
                      allowClear
                      maxTagCount="responsive"
                      style={{
                        width: "100%",
                      }}
                      value={this.state.selected_city}
                      onChange={(value) => {
                        this.setState({
                          selected_city: value,
                        });
                      }}
                      placeholder={t("please_select_a_report")}
                    >
                      {mapped_cities.length > 0 &&
                        mapped_cities.map((cities, index) => (
                          <Option value={cities.id}>{cities.city}</Option>
                        ))}
                    </Select>
                  </Form.Item>
                )}
                <Row gutter={16} align="middle">
                  <Col span={12}>
                    <Form.Item
                      name="heading"
                      label={t("report")}
                      labelCol={{ style: { whiteSpace: "nowrap" } }}
                      style={{ width: "100%" }}
                    >
                      <Select
                        style={{
                          width: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        value={this.state.report_type}
                        onChange={this.selectReportType}
                        placeholder={t("please_select_a_report")}
                      >
                        {["4", "12", "9", "10"].includes(user.role) && (
                          <Option
                            key={1}
                            value="more_than_two_plus_list"
                            label={t("accused_combined_list_2_plus")}
                          >
                            {t("accused_combined_list_2_plus")}
                          </Option>
                        )}

                        <Option value="new arophi">
                          {t("accused_new_cases_statistics")}
                        </Option>
                        <Option value="arophi count">
                          {t("2_plus_report")}
                        </Option>
                        <Option value="arophi_new_list">
                          {t("two_plus_accused_list")}
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    {this.state.report_type !== "new arophi" && (
                      <Form.Item
                        name="type"
                        label={t("type")}
                        labelCol={{ style: { whiteSpace: "nowrap" } }}
                        style={{ width: "100%" }}
                      >
                        <Select
                          style={{
                            width: "100%",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          value={this.state.filter}
                          onChange={this.selectfilter}
                          placeholder={t("please_select_a_report")}
                        >
                          <Option value="by_distinct">
                            {this.state.report_type === "arophi count" ||
                            this.state.report_type === "more_than_two_plus_list"
                              ? t("info_within_police_station_limits")
                              : t("info_within_police_station_crime")}
                          </Option>

                          <Option value="by_id">
                            {this.state.report_type === "arophi count" ||
                            this.state.report_type === "more_than_two_plus_list"
                              ? t("data_entered_by_police_station")
                              : t("data_entered_by_police_crime")}
                          </Option>
                        </Select>
                      </Form.Item>
                    )}
                  </Col>
                </Row>

                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: "12px",
                    marginTop: 8,
                  }}
                >
                  {this.state.activeMainTab === "list" &&
                    this.state.report_type == "history_sheeter" &&
                    this.state.showList === "यादी" && (
                      <Select
                        defaultValue={this.state.districtIds}
                        placeholder={t("please_select_an_option")}
                        value={this.state.districtIds}
                        onChange={(value) =>
                          this.setState({ districtIds: value })
                        }
                        style={{ minWidth: "160px" }}
                      >
                        {basicDistricts &&
                          basicDistricts.length > 0 &&
                          basicDistricts.map((dis) => (
                            <Option key={dis.id}>{dis.DistrictName}</Option>
                          ))}
                      </Select>
                    )}

                  {this.state.report_type != "history_sheeter" && (
                    <>
                      <DatePicker
                        style={{ minWidth: "150px" }}
                        value={
                          report_4_startDate ? moment(report_4_startDate) : null
                        }
                        onChange={this.onStartDateChange}
                        placeholder="DD/MM/YYYY"
                        allowClear
                        format={"DD/MM/YYYY"}
                        inputReadOnly
                        disabled={
                          (this.state.report_type == "arophi count" ||
                            this.state.report_type == "arophi_new_list") &&
                          !this.state.filter
                        }
                      />
                      <DatePicker
                        style={{ minWidth: "150px" }}
                        value={
                          report_4_endDate ? moment(report_4_endDate) : null
                        }
                        onChange={this.onEndDateChange}
                        placeholder="DD/MM/YYYY"
                        allowClear
                        disabledDate={this.disabledEndDate}
                        format={"DD/MM/YYYY"}
                        inputReadOnly
                        disabled={
                          (this.state.report_type == "arophi count" ||
                            this.state.report_type == "arophi_new_list") &&
                          !this.state.filter
                        }
                      />
                    </>
                  )}

                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    disabled={this.isFindDisabled()}
                    loading={this.state.report4_API_loader}
                    onClick={this.handleFind}
                  >
                    {t("find")}
                  </Button>

                  {this.state.activeMainTab === "list" && (
                    <>
                      <Select
                        placeholder={t("please_select_an_option")}
                        value={this.state.download || "excel"}
                        onChange={(value) => this.setState({ download: value })}
                        style={{ minWidth: "180px" }}
                      >
                        <Option key="arophi_excel">{t("accused_excel")}</Option>
                        {this.state.showList === "यादी" && (
                          <Option key="guna_excel">
                            {t("crime_statistics")}
                          </Option>
                        )}
                       {/* <Option key="pdf">PDF</Option>
                        {(this.state.showList === "यादी" ||
                          this.state.report_type === "arophi_new_list") && (
                          <Option key="guna_pdf">
                            {t("crime_statistics")} PDF
                          </Option>
                        )}
                        */}
                      </Select>

                      <Button
                        icon={<DownloadOutlined />}
                        onClick={() => this.downloadReport()}
                        disabled={
                          !this.state.report4_List1?.length ||
                          !this.state.report4_List?.length
                        }
                      >
                        {t("download")}
                      </Button>

                      {(this.state.showList === "यादी" ||
                        this.state.report_type === "arophi_new_list") && (
                        <Button
                          icon={<FilterOutlined />}
                          onClick={() =>
                            this.setState({
                              showFilterSection: !this.state.showFilterSection,
                            })
                          }
                          disabled={
                            !this.state.report4_List.length ||
                            !this.state.report4_List1.length ||
                            !this.state.arophiList.length
                          }
                        >
                          {t("filter")}
                        </Button>
                      )}
                    </>
                  )}
                </div>

                {/* {this.state.showFilterSection && (
                  <Descriptions.Item>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "16px",
                        alignItems: "flex-start",
                      }}
                    >
                      {(this.state.report_type === "arophi_new_list" ||
                        (this.state.report_type === "arophi count" &&
                          this.state.showList !== "सांख्यिकी")) && (
                        <div
                          style={{
                            marginTop: "16px",
                            padding: "16px",
                            background: "#fff",
                            borderRadius: "8px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "16px",
                            marginBottom: "25px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <Form.Item
                              name="heading"
                              label="शीर्षक"
                              style={{
                                width: "100%",
                                maxWidth: "500px",
                                minWidth: "280px",
                                flex: "1",
                              }}
                            >
                              <Select
                                mode="multiple"
                                allowClear
                                style={{ width: "100%" }}
                                placeholder={t("please_select_a_title")}
                                onChange={(val) =>
                                  this.setState({ crimeTitle: val })
                                }
                              >
                                {pc_crimetitles?.map((res, index) => (
                                  <Option key={index} value={res.id}>
                                    {res.crime_title}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: "12px",
                            }}
                          >
                            <Button
                              key="1"
                              type="primary"
                              disabled={
                                !this.state.report_4_startDate ||
                                this.state.isMoreThanOneYear
                              }
                              loading={this.state.report4_API_loader}
                              onClick={this.getData}
                              className="modern-button"
                            >
                              {t("find")}
                            </Button>
                          </div>
                        </div>
                      )}
                    </div>
                  </Descriptions.Item>
                )} */}
                {this.state.activeMainTab === "list" &&
                  this.state.showList === "यादी" &&
                  this.state.report_type != "new arophi" &&
                  (this.state.report4_List.length > 0 ||
                    this.state.arophiList.length > 0 ||
                    this.state.arophiCount.length > 0 ||
                    this.state.arophiListCount.length > 0 ||
                    this.state.newArophiData.length > 0) && (
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <label style={{ fontSize: "15px", fontWeight: "500" }}>
                        फोटो:
                      </label>

                      <Radio.Group
                        onChange={this.handleAdvancedFilterPhotoChange}
                        value={this.state.advancedFilterPhoto}
                      >
                        <Radio value="all">सर्व</Radio>
                        <Radio value="yes">होय</Radio>
                        <Radio value="no">नाही</Radio>
                      </Radio.Group>
                    </div>
                  )}
                {this.state.activeMainTab === "list" &&
                  this.state.showFilterSection == true && (
                    <div
                      style={{
                        marginTop: "16px",
                        padding: "16px",
                        background: "#fff",
                        borderRadius: "8px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                        marginBottom: "25px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "16px",
                          flexWrap: "wrap", // responsive wrap
                        }}
                      >
                        {/* Title Select */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flex: 1,
                          }}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#262626",
                              minWidth: "100px",
                              marginRight: "8px",
                            }}
                          >
                            शीर्षक:
                          </span>
                          <Select
                            mode="multiple"
                            allowClear
                            style={{ flex: 1 }}
                            placeholder={t("please_select_a_title")}
                            onChange={(val) =>
                              this.setState({ crimeTitle: val })
                            }
                            value={this.state.crimeTitle}
                          >
                            {pc_crimetitles?.map((res, index) => (
                              <Option key={index} value={res.id}>
                                {res.crime_title}
                              </Option>
                            ))}
                          </Select>
                        </div>

                        {/* Sort By Dropdown */}
                        <Dropdown
                          overlay={menu}
                          placement="bottomRight"
                          arrow={{ pointAtCenter: true }}
                          overlayStyle={{ width: "200px" }}
                        >
                          <Button
                            type="primary"
                            style={{
                              minWidth: "140px",
                              backgroundColor: "#1890ff",
                              borderColor: "#1890ff",
                            }}
                            className="modern-button"
                          >
                            {t("sorter_by")} <DownOutlined />
                          </Button>
                        </Dropdown>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "12px",
                        }}
                      >
                        <Button
                          disabled={
                            !(
                              this.state.crimeTitle.length > 0 ||
                              (this.state.order_by && this.state.direction)
                            )
                          }
                          loading={this.state.report4_API_loader}
                          onClick={this.getData}
                          type="primary"
                          icon={<SearchOutlined />}
                          className="modern-button modern-button-success"
                        >
                          {t("find")}
                        </Button>

                        {this.state.is_sort && (
                          <Button
                            onClick={() => this.clearFilter()}
                            icon={<ClearOutlined />}
                            className="modern-button modern-button-danger"
                          >
                            {t("clear")}
                          </Button>
                        )}
                      </div>
                    </div>
                  )}
                {this.state.report_type != "new arophi" &&
                  !this.state.filter && (
                    <Text type="danger">
                      {t("please_select_report_and_type")}
                    </Text>
                  )}
                {this.state.isMoreThanOneYear && (
                  <Text type="danger">
                    कृपया 5 वर्ष किंवा त्या पेक्षा कमी कालावधी निवडा.
                  </Text>
                )}
              </PageHeader>

              <Modal
                title="आरोपी प्रोफाइल"
                top
                visible={this.state.setCriminalViewModel}
                onOk={this.closeCriminalViewModel}
                onCancel={this.closeCriminalViewModel}
                width={95 + "%"}
              >
                <ViewFormModel
                  key={this.props && this.props.user.id}
                  dataStates={professionals}
                ></ViewFormModel>
              </Modal>
              <React.Suspense fallback={<div>Loading...</div>}>
                {this.state.report_type == "new arophi" ||
                this.state.report_type == "arophi count" ||
                this.state.report_type == "arophi_new_list" ||
                this.state.report_type == "more_than_two_plus_list" ||
                this.state.report_type == "history_sheeter" ? (
                  <AropiReport2Plus
                    report_type={this.state.report_type}
                    startDate={reportStartDate}
                    endDate={reportEndDate}
                    onViewAccusedForm={this.onViewAccusedForm}
                    cityId={user.cityId}
                    newArophiData={this.state.newArophiData}
                    arophiCount={this.state.arophiCount}
                    arophiList={this.state.arophiList}
                    arophiListCount={this.state.arophiListCount}
                    historyList={this.state.historyList}
                    historyCount={this.state.historyCount}
                    showList={reportShowList}
                    getShowList={this.getShowList}
                    user={user}
                    total={this.state.total}
                    loading={this.state.report4_API_loader}
                    professionals={this.props.professionals}
                    preventiveAction={this.state.preventiveAction}
                    filter={this.state.filter}
                    selectedCity={
                      this.props.user.role === "12" && this.state.selected_city
                    }
                    graphOnly={isGraphTab}
                    graphRefreshKey={this.state.graphRefreshKey}
                    showGraphToggle={
                      user.role === "4" ||
                      user.role === "9" ||
                      (user.role == "10" &&
                        this.state.report_type !== "new arophi")
                    }
                    isGraphView={isGraphTab}
                    onToggleGraph={this.toggleGraphView}
                    onTableSortChange={this.handleTableSortChange}
                    onDistrictFilterChange={this.handleDistrictFilterChange}
                    onPreventiveFilterChange={this.handlePreventiveFilterChange}
                    onVisibleRowsChange={this.handleVisibleRowsChange}
                  />
                ) : (
                  <TableReport2Plus
                    key={this.state.report4_List}
                    data={this.state.report4_List}
                    allTotal={this.state.report4_List.length}
                    total={this.state.total}
                    // total={this.state.report4_List.length}
                    onViewAccusedForm={this.onViewAccusedForm}
                    preventiveAction={this.state.preventiveAction}
                  ></TableReport2Plus>
                )}
              </React.Suspense>
            </div>
          </div>
        </Spin>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  const {
    pc_cities,
    basicDistricts,
    pc_status,
    pc_crimetitles,
    pc_crimetypes,
    pc_countrystates,
  } = professionals;
  return {
    user,
    users,
    professionals,
    basicDistricts,
  };
}

const connectedPlus2ReportAdmin = connect(mapStateToProps)(Plus2ReportAdmin);
export { connectedPlus2ReportAdmin as Plus2ReportAdmin };
